import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { Constant } from 'src/app/constant/constant';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { getPageSize } from 'src/app/shared/utils/calsoft-validators';
import { DatePipe, Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { EmailSendService } from 'src/app/services/email-send.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { filter, takeUntil } from "rxjs/operators";

@Component({
  selector: 'calsoft-send-all-email',
  templateUrl: './send-all-email.component.html',
  styleUrls: ['./send-all-email.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('closed', style({
        height: '0',
        overflow: 'hidden',
        opacity: '0'
      })),
      state('open', style({
        height: '*',
        overflow: 'visible',
        opacity: '1'
      })),
      transition('closed <=> open', animate('300ms ease-in-out'))
    ])
  ]
})
export class SendAllEmailComponent implements OnInit {

  url = '';
  sanitizedUrl = '';


  @Input() type: any = 1;

  @Input() leadId: any = 0;
  dialerShow: boolean;
  redirected: boolean;
  textAccount: string;

  constructor(
    private emailSendService: EmailSendService,
    private router: Router,
    private location: Location,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });

  }


  @Input() columns: ListColumn[] = []

  filterSelectObj = [];
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;


  ngOnInit(): void {

    this.columns = [

      { name: 'Client Name', property: 'clientName', visible: true, isModelProperty: true },
      { name: 'Email', property: 'email', visible: true, isModelProperty: false },
      { name: 'Subject', property: 'subject', visible: true, isModelProperty: false },
      { name: 'Body', property: 'body', visible: false, isModelProperty: false },
      { name: 'Opened', property: 'opened', visible: true, isModelProperty: false },
      { name: 'Opened Time', property: 'openedTime', visible: true, isModelProperty: true },
      { name: 'Clicked', property: 'clicked', visible: true, isModelProperty: true },
      { name: 'Status', property: 'status', visible: true, isModelProperty: true },
      { name: 'Error', property: 'errorMessage', visible: true, isModelProperty: true },
      //{ name: 'Action', property: 'actions', visible: true, disabled: true },
    ] as ListColumn[];


    this.filterSelectObj = [
      {
        name: 'Client Name',
        property: 'clientName',
        type: 'text',
        position: 'firstValue',
        options: []
      },
      {
        name: 'Email',
        property: 'email',
        type: 'text',
        position: 'secondValue',
        options: []
      },
      {
        name: 'Subject',
        property: 'subject',
        type: 'text',
        position: 'thirdValue',
        options: []
      },
    ]



    if (this.leadId > 0) {
      this.getAllSendEmails();
    } else {

      this.sendEmailList = [];
    }


  }
  isPopupOpenTwo = false;
  BusinessList: any = [];
  BusinessTypeList: any = [];
  filteredBusinessTypeList: any = [];

  totalElements: number = 0;
  sortParam: any = 'id' + "," + Constant.Dsc;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  sendEmailList: any = [];
  private dateFormat = Constant.dateFormat;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  spinner: boolean;
  totalLeadCount: any;
  elements: any
  pageList: any;

  pageSizeValue: any;
  sortParamInit: any = 'id' + "," + Constant.Dsc;

  getAllSendEmails() {
    this.spinner = true;

    this.emailSendService.getAllEmailSendByLeadId(this.leadId, this.type, this.page, this.size, this.sortParam).subscribe(
      res => {
        console.log(res);
        this.spinner = false;
        this.sendEmailList = new MatTableDataSource();
        this.sendEmailList = res['content'];
        this.elements = res['numberOfElements'];
        this.sendEmailList.sort = this.sort;
        this.sendEmailList.paginator = this.paginator;
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
      }
    )
  }

  getUpdate(event) {

    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;


    let localtion = this.router.url;
    const questionMarkIndex = localtion.indexOf('?');



    if (questionMarkIndex !== -1) {
      // Extract the substring before the ?
      const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

      // Replace the original string with the substring before the ?
      localtion = beforeQuestionMark;
    }

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];

    localtion = localtion.split('&page')[0]


    if (this.sortParam == undefined) {

      this.sortParam = 'id' + "," + Constant.Dsc;

    }

    this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

    this.redirected = false;

    this.getAllSendEmails();
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }


  sortData(event) {
    if (event.active != 'categoryNames' && event.active != 'icons' && event.active != 'select' && event.active != 'actions') {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.sortParam = event.active;
      if (event.direction == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (event.direction == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.getAllSendEmails();
    }
  }


  addSendEmail() {
    let id = 0;
    this.router.navigate([`/emailSend/addEmailSend/${id}`])

  }

  editSendEmail(id) {
    this.router.navigate([`/emailSend/editEmailSend/${id}`])
  }

  // editGoogleCalendar(id) {
  //   const dialogRef = this.dialog.open(AddMeetingComponent, {
  //     width: '80%',
  //     maxWidth: '1200px',
  //     height: '100%',
  //     data: {
  //       "id": id,
  //       "type": 2,
  //     },
  //     position: { right: '0' },
  //     panelClass: 'slide-dialog-panel',
  //     hasBackdrop: true,
  //     disableClose: true
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result && result['event'] === 'add') {
  //       this.getAllSendEmails();
  //     }
  //   });
  // }

  getRelativeTime(dateString: string): string {
    const activityDate = new Date(dateString);
    const now = new Date(); // Using component initialization time for consistency
    const diffInSeconds = Math.floor((now.getTime() - activityDate.getTime()) / 1000);

    const intervals: { [key: string]: number } = {
      'year': 31536000,
      'month': 2592000,
      'day': 86400,
      'hour': 3600,
      'minute': 60
    };

    for (const intervalName in intervals) {
      const interval = intervals[intervalName];
      const count = Math.floor(diffInSeconds / interval);
      if (count > 0) {
        return `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
      }
    }
    return 'Just now';
  }

  toggleEmailDetails(row: any): void {
    row.showEmailDetails = !row.showEmailDetails;
  }

  links:any;

  toggleEmailTrackingId(row): void {

     row.showEmailLinksDetails = !row.showEmailLinksDetails;

    this.emailSendService.getEmailSendByTrackingId(row.trackerId)
      .subscribe(
        (res) => {

            this.links = res; 
            
            console.log("links" , this.links);
            

        }

      );

  }

    protected _onDestroy = new Subject<void>();

    sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
